import type { MaintenanceActivity } from '../../../../Helpers/maintenanceCostUtils';

/** The longest comment an activity row may carry */
export const ACTIVITY_COMMENT_MAX_LENGTH = 500;

/**
 * The comment as it is stored: trimmed and capped, or undefined when empty,
 * so the field is absent rather than an empty string.
 */
export const normalizeActivityComment = (text: string): string | undefined => {
    // Cut by code points, so an emoji at the limit is not split in half
    const trimmed = Array.from(text.trim()).slice(0, ACTIVITY_COMMENT_MAX_LENGTH).join('').trim();
    return trimmed === '' ? undefined : trimmed;
};

/**
 * The activity with its comment set from the typed text; the same object when
 * nothing changes. `lastUpdated` is left alone: Ekonomi reads it as the date the
 * activity's price was set, and a comment says nothing about the price.
 */
export const withActivityComment = (activity: MaintenanceActivity, text: string): MaintenanceActivity => {
    const comment = normalizeActivityComment(text);
    if (comment === activity.comment) return activity;
    const { comment: _previous, ...rest } = activity;
    return comment ? { ...rest, comment } : rest;
};
